import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IconView32wln42r1v8cb as IconView } from '../direct/IconView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../direct/modifiers.commonHtml.mjs';
import { ErrorSemantic_getInstanceqmizdq1y2zzq as ErrorSemantic_getInstance } from '../../models/Theme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  plus18eogev54fmsa as plus,
  minus27abgkurcn6u0 as minus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function icon(_this__u8e3s4, icon, description, setup) {
  var tmp;
  if (setup === VOID) {
    tmp = icon$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (IconView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.sbt(icon);
  view.gbu(description);
  setup(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function errorText(_this__u8e3s4) {
  // Inline function 'kotlin.collections.setOf' call
  var tmp$ret$0 = emptySet();
  var errors = Signal().hak(tmp$ret$0);
  var tmp = _this__u8e3s4.kbb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(errors).i1();
  }), _this__u8e3s4.jbb(ErrorSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var $this$text = view;
  _this__u8e3s4.vba(new (errorText$3())(errors));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl($this$text);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb($this$text));
  reactiveScope($this$text, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.daj(errors);
    var tmp$ret$2 = joinToString(tmp, '\n', VOID, VOID, VOID, VOID, (it) => {
      var tmp0_safe_receiver = $this$text.abb(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ucv_1;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? it.message : tmp1_elvis_lhs;
      return tmp2_elvis_lhs == null ? it.toString() : tmp2_elvis_lhs;
    });
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function icon$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var errorText$3Class;
function errorText$3() {
  if (errorText$3Class === VOID) {
    class $ {
      constructor($errors) {
        this.qdl_1 = $errors;
      }
      g90() {
        return 1.0;
      }
      scv(view, working, exception) {
        var _receiver__tnumb7 = this.qdl_1;
        _receiver__tnumb7.oam(plus(_receiver__tnumb7.f2(), exception));
        return () => {
          var _receiver__tnumb7 = this.qdl_1;
          _receiver__tnumb7.oam(minus(_receiver__tnumb7.f2(), exception));
          return Unit_instance;
        };
      }
    }
    initMetadataForClass($);
    errorText$3Class = $;
  }
  return errorText$3Class;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
//region block: exports
export {
  errorText as errorTextv58wi1t0me7u,
  icon as icon1sxjaie5w1apt,
};
//endregion

//# sourceMappingURL=shortstuff.mjs.map
